import React, { Children } from 'react';

import type { WizardContextType } from '../context';
import { WizardContext } from '../context';

const Steps = ({ children }: { children: React.ReactNode }) => (
  <WizardContext.Consumer>
    {({ activeStepIndex }: WizardContextType) => {
      return Children.toArray(children)[activeStepIndex];
    }}
  </WizardContext.Consumer>
);

Steps.displayName = 'Steps';
export { Steps };
